import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-5">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-heading font-semibold tracking-wide text-background-50 whitespace-nowrap">
                  喵绅士
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed max-w-xs">
                高雅猫咪文化与精品生活方式平台。汇聚猫咪文化、绅士美学与精致生活，让每一位爱猫人都能活得像一位真正的喵绅士。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                <a href="#footer-nav" className="no-underline text-background-50">快速导航</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/cat-culture" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">猫咪文化</Link></li>
                <li><Link to="/category/gentleman-aesthetics" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">绅士美学</Link></li>
                <li><Link to="/category/cat-care-guide" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">养猫指南</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                <a href="#footer-cats" className="no-underline text-background-50">精选内容</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/article/art-of-cat-tea-ceremony" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">猫与茶道</Link></li>
                <li><Link to="/article/gentleman-cat-wardrobe" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">绅士猫的衣橱</Link></li>
                <li><Link to="/article/cats-in-literature" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">文学中的猫</Link></li>
                <li><Link to="/article/rescue-cat-story" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">领养日记</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                <a href="#footer-contact" className="no-underline text-background-50">联系我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base w-4 h-4 flex items-center justify-center" />
                  <span>hello@yufangwlkk.cn</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line text-base w-4 h-4 flex items-center justify-center" />
                  <span>上海市静安区愚园路168号</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-phone-line text-base w-4 h-4 flex items-center justify-center" />
                  <span>021-5208-6666</span>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-5">
                <a href="https://weibo.com" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300" aria-label="微博">
                  <i className="ri-weibo-line text-sm" />
                </a>
                <a href="https://www.xiaohongshu.com" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-all duration-300" aria-label="小红书">
                  <i className="ri-chat-smile-2-line text-sm" />
                </a>
                <a href="https://weixin.qq.com" rel="nofollow" target="_blank" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-secondary-500 hover:text-background-50 transition-all duration-300" aria-label="微信">
                  <i className="ri-wechat-line text-sm" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 喵绅士 Mr. Meow. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}